/**
 * @deprecated `Avatar` is deprecated please use `AvatarView` instead
 */
export enum AvatarType {
  THUMBNAIL = 'thumbnail',
  ICON = 'icon',
  EMOJI = 'emoji',
  INITIALS = 'initials',
}
